<template>
  <multiselect
    :multiple="true"
    :options="options"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :value="selections"
    class="multiple"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε brand με χρήση τίτλου..."
    selected-label="Επιλεγμένο"
    select-label="Πατήστε enter για επιλογή"
    deselect-label="Πατήστε enter για απο-επιλογή"
    data-vv-value-path="value"
    data-vv-name="brand"
    @search-change="searchBrands"
    @select="selectBrand"
    @remove="removeBrand"
  >
    <template v-slot:option="props" class="option">
      <Photo :photos="props.option.photos" class="option__image" />
      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import request from '@/utils/request';
import Photo from '@/views/components/Photo';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
    Photo,
  },
  props: {
    selections: Array,
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchBrands: _debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/brands-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.options = data.brands;
      }
    }, 300),
    selectBrand(selectedOption) {
      this.$emit('on-select', selectedOption);
    },
    removeBrand(selectedOption) {
      this.$emit('on-remove', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;
}
</style>
